<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <transition :name="SkipSwitchName">
      <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    </transition>
    <div v-if="$store.state.isSim" class="sim-tag">{{$t('trade').simulatedTrading }}</div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import systemApi from '@/api/system'

export default {
  name: 'App',

  data() {
    return {
      SkipSwitchName: '',
      show: false
    }
  },
  created() {
    this.getbasic()
  },
  mounted() {
    document.documentElement.className = localStorage.getItem('theme')
    EventBus.$on('theme', (val) => {
      document.documentElement.className = val
    })
    EventBus.$on('Login', () => {
    })
    EventBus.$on('Logout', () => {
    })
    if (process.env.NODE_ENV === 'development') {
      // new this.$vconsole()
    }
  },
  methods: {
    async getbasic() {
      let localLang = ''
      localLang = localStorage.getItem('language') || 'en' // 默认语言
      this.$i18n.locale = localLang
      this.$store.commit('SET_LANG', localLang, false)
      localStorage.setItem('language', localLang)
      //平台名称 logo
      const res = await systemApi.getConfig()
      localStorage.setItem('platformName', res.systemSetting.platformName) // 平台名称
      localStorage.setItem('platformLogo', window.baseURL + res.systemSetting.platformLogo)// 平台logo
      document.title = res.systemSetting.platformName
      document.querySelector("link[rel~='icon']").href = window.baseURL + res.systemSetting.platformLogo
      this.show = true
    }
  }
}
</script>
<style>
/* 全局 CSS 变量定义 - 亮色主题 */
:root {
  --primary_color: #00cdcf;
  /* 主色 */
  --background_color: #ffffff;
  /* 背景颜色 */
  --info_color: #eeeeee;
  /* 次背景颜色 */
  --text_color: #03132c;
  /* 文本颜色 */
  --ntext_color: #7e8797;
  /* 次文本颜色 */
}

/* 暗色主题定义 */
.dark {
  --primary_color: #00cdcf;
  /* 主色 */
  --background_color: #151517;
  /* 背景颜色 */
  --info_color: #2c2e33;
  /* 次背景颜色 */
  --text_color: #ffffff;
  /* 文本颜色 */
  --ntext_color: #a3a3a5;
  /* 次文本颜色 */
}
</style>
<style lang="less">
* {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
  user-select: none;
  /* Standard syntax */
  cursor: pointer;
}
input,
textarea {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
  cursor: text !important;
}
.sim-tag {
  position: fixed;
  right: 0;
  top: 40%;
  z-index: 9999;
  opacity: 0.5;
  background: var(--text_color);
  color: var(--background_color);
  padding: 8px 6px;
  font-size: 14px;
  font-weight: bold;
  writing-mode: vertical-rl;
  letter-spacing: 2px;

  border-radius: 6px 0 0 6px;
}
</style>
